import type { FaireProductEntity } from "../../entity_types/product";

export const p_hm48qy3ny4: FaireProductEntity = {
  token: "p_hm48qy3ny4",
  type: "product",
  name: "Crescent Sport Bag - Bone",
  brandToken: "b_qa8gaqqvwt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0ad4dbe5897f01197b4305e989af9de013db6452c7f8bb4d1a74f32f302239ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a93d39691495ef31d635c935098337a57b858537065cd6b6c034ff1a6292e20.jpeg",
    "https://cdn.faire.com/fastly/bbadf4a122b4499b4b5aabf7b67aaa782f25d258d10248f8e7b8ac0e14a1eb94.jpeg",
    "https://cdn.faire.com/fastly/7e345ed897bbc2edeee6cac2ab5fe662ea3200e0192f44b04d063cdefc326232.jpeg",
    "https://cdn.faire.com/fastly/e332a838a533b3e757af66f53e23ab1dd66a616d55f1d6c71626e72050616e3a.jpeg",
    "https://cdn.faire.com/fastly/8a9bbb563cc94a43cfaf107d7ffb022cb1bd2b8ab67b9d2f50daeb8a07ea81b3.jpeg",
    "https://cdn.faire.com/fastly/41d27e8abe1a2484e23ebd824a857b0a00c741d3f647ba8e77f2d56796bb5f38.jpeg",
    "https://cdn.faire.com/fastly/142d6c5707506fc0a91540d41592418ad43a68a8fc4976a8e6205f9df26e608b.jpeg",
    "https://cdn.faire.com/fastly/a65ee9bce0b5f8cf42691381a1be1761c7d143c759a2db9eeef7e56464f56205.jpeg",
    "https://cdn.faire.com/fastly/88ff6576e22013ab33cd8fc37fcf0868e6b133d40018875129f2b29381e55f19.jpeg",
    "https://cdn.faire.com/fastly/9a3e61b605b9f8b24559dae49b4a454327f949ad1eb926992a9a7e211c6b0eee.jpeg",
    "https://cdn.faire.com/fastly/66312336a33417e8963af174a5a89d69350b427e48bf82f6ba02c9244c2ac975.jpeg",
    "https://cdn.faire.com/fastly/6979c8071b7e8403e800b329a254d1c27e23185a476e36c9b5f261afeaf2606a.jpeg",
    "https://cdn.faire.com/fastly/8930edd1f3d989d85af48423eadd7ef9acb816297b088b5b941701b79502d2de.jpeg",
    "https://cdn.faire.com/fastly/826d9bf0506cf19a6665eb166d02f9090d8937903bb2359809b7e09e765538bd.jpeg",
  ],
  priceDollars: 52.5,
  description:
    "The perfect Vitality gym accessory, the Crescent Sport Bag is a cute all-in-one gym bag with adjustable straps and specific storage solutions for your toiletries, water bottle, yoga mat, keys, and wet clothes or dirty shoes.\n",
  tags: [],
  msrpDollars: 105,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:49.270Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
